import { Form, Picker } from "antd-mobile";

/**
 * 单项选择框
 * @param {
 *  setFormInfo:向传给接口的对象中新增对应表单数据
 *  getUserObj:根据对应的api,key,获取数据,插入到content[postName]中
 *  content:选择框内数据
 * } props
 * @returns
 */
export function BpmFormPicker(props) {
  const {
    postName,
    label,
    required,
    message,
    api,
    key,
    disabled,
    pickerTitle,
    placeholder,
  } = props.item;
  const { setFormInfo, content, setContent, getUserObj, postData } = props;



  /** 点击弹出选择框 */
  const onClick = (e, PickerRef) => {
    // 后端数据为022,为了判断写为！=
    // eslint-disable-next-line eqeqeq
    if (label === "灵活就业方式" && postData.FWORKTYPE != 22) {
      return;
    }
    getUserObj(api, key, postName, content, setContent);
    PickerRef.current?.open();
  };

  /** 点击确认 */
  const onConfirm = (value) => {
    const val = value[0];
    if (val === "暂无数据") {
      return;
    }
    setFormInfo(postName, value[0]);
  };

  /** 表单上显示的值 */
  const isValue = (value) => {
    // 后端数据为022,为了判断写为！=
    // eslint-disable-next-line eqeqeq
    if (label === "灵活就业方式" && postData.FWORKTYPE != 22) {
      return placeholder;
    } else {
      if (value.length > 0) {
        if (value[0].label === "暂无数据") {
          return placeholder;
        } else {
          return value[0].label;
        }
      } else {
        return placeholder;
      }
    }
  };
  /**
   * 处理columns
   * @param {*} columns  列表数据
   */
  const getColumns = (content, postName) => {
    const columns = content[postName] || [];
    if (columns && columns.length > 0) {
      // 遍历columns，给每一项添加上key
      columns.forEach((item) => {
        item.key = item.value;
      });
      return [columns];
    } else {
      return [[{ label: "暂无数据", value: "暂无数据", key: "暂无数据" }]];
    }
  };

  return (
    <Form.Item
      name={postName}
      label={label}
      disabled={disabled}
      rules={[{ required: required, message: message }]}
      trigger="onConfirm"
      onClick={(e, PickerRef) => onClick(e, PickerRef)}
    >
      <Picker
        className={label === '人员类别' ? 'wrapPicker' : ''}
        title={pickerTitle}
        closeOnMaskClick={false}
        columns={getColumns(content, postName)}
        onConfirm={(value) => onConfirm(value)}
      >
        {(value) => isValue(value, placeholder)}
      </Picker>
    </Form.Item>
  );
}
